export default __webpack_public_path__ + "static/2581-1fa92a1174261dc26800c284f79a6218.jpg";